<!-- <div id="inlinecalendar">
  @if (from == undefined) {
  <div class="col-md-12 col-sm-12 col-lg-12  Fortnight">
    <div class="row align-items-center">
      <div class="col-lg-12 col-md-12 col-12">
        <div class="d-flex jus_c_right gap-3 flex-wrap availability-legends">
          <div class="text-legend align-items-center d-flex">
            <div class="user-sub-title available-color mr-5"></div>
            <div class="txt-regular">Available</div>
          </div>
          <div class="text-legend align-items-center d-flex ml-5">
            <div class="havent-indicated user-sub-title mr-5"></div>
            <div class="txt-regular">Haven’t Indicated</div>
          </div>
          <div class="text-legend align-items-center d-flex ml-5">
            <div class="booked user-sub-title mr-5"></div>
            <div class="txt-regular">Booked</div>
          </div>
          <div class="text-legend align-items-center d-flex ml-5">
            <div class="booked-elsewhere user-sub-title mr-5"></div>
            <div class="txt-regular">Booked Elsewhere</div>
          </div>
          <div class="text-legend align-items-center d-flex ml-5">
            <div class="unavailable user-sub-title mr-5"></div>
            <div class="txt-regular">Unavailable</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10">
      <a class="c-p text-regular-bold float-left h_b t-dec-none h_b clr-cc-vilot" appFocus appClick role="button"
        aria-label="Previous Fortnight" (click)="prevClick(teacherID);"><i
          class="bi fs-20 bi-arrow-left-short v-align-m"></i> Previous
        Fortnight</a>
      <a class="c-p text-regular-bold float-right h_b t-dec-none h_b clr-cc-vilot" appFocus appClick role="button"
        aria-label="Next Fortnight" (click)="nextClick(teacherID);">Next
        Fortnight <i class="bi bi-arrow-right-short fs-20 v-align-m"></i></a>
    </div>
    <div class="call-outs mt-10">
      @for (availability of availability; track availability) {
      <span class="availability-grid">
        <div class="call-out {{availability.day}}" [ngClass]="availability.intervals.length > 1 ? 'half-day': ''">
          @if (availability.intervals.length == 1) {
          <span>
            <div class="link user-{{availability.intervals[0].status}} tooltipss"
              [attr.aria-label]="availability.tool_tip +''+availability.intervals[0].display_status" appFocus>
              @if (availability.day == 'Mon' || availability.day == 'Tue' || availability.day == 'Wed' ||
              availability.day == 'Thu' || availability.day == 'Fri') {
              <span aria-hidden="true"
                class="tooltiptext txt-regular clr-white">{{availability.tool_tip}}<br>{{availability.intervals[0].display_status}}</span>
              }
              @if (availability.day == 'Mon' || availability.day == 'Tue' || availability.day == 'Wed' ||
              availability.day == 'Thu' || availability.day == 'Fri') {
              <a>
                {{availability.date}}
              </a>
              }
              @if (availability.day == 'Sat' || availability.day == 'Sun') {
              <a>
                <i class="bi bi-calendar-x sat-sun-icon"></i>
              </a>
              }
            </div>
          </span>
          }
          @if (availability.intervals.length > 1) {
          <span>
            <div class="user-{{availability.intervals[0].status}} tooltipsss" appFocus
              [attr.aria-label]="availability.tool_tip +''+availability.intervals[0].display_status"
              [ngClass]="availability.intervals.length[0] ? 'link-interval': 'link-interval'">
              <span aria-hidden="true"
                class="tooltiptext txt-regular clr-white">{{availability.tool_tip}}<br>{{availability.intervals[0].display_status}}</span>
              @if (availability.day == 'Mon' || availability.day == 'Tue' || availability.day == 'Wed' ||
              availability.day == 'Thu' || availability.day == 'Fri') {
              <a>
                {{availability.date}}
              </a>
              }
              @if (availability.day == 'Sat' || availability.day == 'Sun') {
              <a>
                <i class="bi bi-calendar-x sat-sun-icon"></i>
              </a>
              }
            </div>

            <div class="link-intervals user-{{availability.intervals[1].status}} tooltipssss"
              [attr.aria-label]="availability.tool_tip +''+availability.intervals[0].display_status" appFocus>
              <span
                class="tooltiptext txt-regular clr-white">{{availability.tool_tip}}<br>{{availability.intervals[1].display_status}}</span>
            </div>

          </span>
          }
        </div>
      </span>
      }

    </div>
  </div>
  }

  @if (from == 'FNT') {
  <div class="call-outs mt-10">
    @for (availability of availability; track availability) {
    <span class="availability-grid">
      <div class="call-out {{availability.day}}" [ngClass]="availability.intervals.length > 1 ? 'half-day': ''">
        @if (availability.intervals.length == 1) {
        <span>
          <div class="link user-{{availability.intervals[0].status}} tooltipss" appFocus
            [attr.aria-label]="availability.tool_tip +''+availability.intervals[0].display_status">
            @if (availability.day == 'Mon' || availability.day == 'Tue' || availability.day == 'Wed' || availability.day
            == 'Thu' || availability.day == 'Fri') {
            <span aria-hidden="true"
              class="tooltiptext txt-regular clr-white">{{availability.tool_tip}}<br>{{availability.intervals[0].display_status}}</span>
            }
            @if (availability.day == 'Mon' || availability.day == 'Tue' || availability.day == 'Wed' || availability.day
            == 'Thu' || availability.day == 'Fri') {
            <a>
              {{availability.date}}
            </a>
            }
            @if (availability.day == 'Sat' || availability.day == 'Sun') {
            <a>
              <i class="bi bi-calendar-x sat-sun-icon"></i>
            </a>
            }
          </div>

        </span>
        }
        @if (availability.intervals.length > 1) {
        <span>
          <div class="user-{{availability.intervals[0].status}} tooltipsss" appFocus
            [attr.aria-label]="availability.tool_tip +''+availability.intervals[0].display_status"
            [ngClass]="availability.intervals.length[0] ? 'link-interval': 'link-interval'">
            <span aria-hidden="true"
              class="tooltiptext txt-regular clr-white">{{availability.tool_tip}}<br>{{availability.intervals[0].display_status}}</span>
            @if (availability.day == 'Mon' || availability.day == 'Tue' || availability.day == 'Wed' || availability.day
            == 'Thu' || availability.day == 'Fri') {
            <a>
              {{availability.date}}
            </a>
            }
            @if (availability.day == 'Sat' || availability.day == 'Sun') {
            <a>
              <i class="bi bi-calendar-x sat-sun-icon"></i>
            </a>
            }
          </div>
          <div class="link-intervals user-{{availability.intervals[1].status}} tooltipssss" appFocus
            [attr.aria-label]="availability.tool_tip +''+availability.intervals[1].display_status">
            <span
              class="tooltiptext txt-regular clr-white">{{availability.tool_tip}}<br>{{availability.intervals[1].display_status}}</span>
          </div>
        </span>
        }
      </div>
    </span>
    }
  </div>
  }
</div>

<div class="call-outs mt-10" *ngIf="isShowPrintStatus">
  <div *ngFor="let day of availability" class="calendar-day">
    <ng-container *ngIf="day.intervals.length === 1">
      <div class="day-block" [attr.title]="day.tool_tip">
        {{ getStatusLabel(day.intervals[0].status) }}
      </div>
    </ng-container>

    <ng-container *ngIf="day.intervals.length > 1">
      <div style="display: flex; gap: 2px;">
        <div *ngFor="let interval of day.intervals" class="day-block"
          [ngStyle]="{ width: interval.percentage_from_day + '%' }" [attr.title]="day.tool_tip">
          {{ getStatusLabel(interval.status) }}
        </div>
      </div>
    </ng-container>
  </div>
</div> -->

<div class="col-md-12 col-sm-12 col-lg-12 Fortnight mb-20" *ngIf="from != 'FNT'">
  <div class="d-flex align-items-center s_between">
    <a class="c-p user-title t-dec-none h_b clr-cc-vilot" (click)="prevFortnight()"><i
        class="bi fs-20 bi-arrow-left-short v-align-m"></i> Previous
      Fortnight</a>
    <p class="text-regular-medium">{{monthsShown}}</p>
    <a class="c-p user-title float-right h_b t-dec-none h_b clr-cc-vilot" (click)="nextFortnight()">Next Fortnight
      <i class="bi bi-arrow-right-short fs-20 v-align-m"></i></a>
  </div>
</div>
<!-- Static Header at Top -->
<div class="calendar-header-row">
  <div class="calendar-header-cell txt-regular" *ngFor="let day of availability">
    <div class="header-day">{{ day.day }}</div>
    <div class="header-date">{{ day.date }} {{ day.month }}</div>
    <!-- <div class="header-month">{{ day.month }}</div> -->
  </div>
</div>


<!-- Regular Calendar View -->
<div class="calendar-content txt-regular">
  <div class="calendar-dates-row" *ngIf="!isShowPrintStatus">
    <div class="calendar-date-cell" *ngFor="let day of availability">
      <!-- SAT/SUN: Grey out and show strikeout calendar icon -->
      <ng-container *ngIf="day.day === 'Sat' || day.day === 'Sun'; else weekdayBlock">
        <div class="circle sat-sun-grey">
          <i class="bi bi-calendar-x sat-sun-icon"></i>
        </div>
      </ng-container>
      <!-- Weekdays: Show status info -->
      <ng-template #weekdayBlock>
        <ng-container *ngIf="day.intervals.length === 1">
          <div class="circle" [ngClass]="getStatusClass(day.intervals[0].status)">
            <span class="circle-label">{{ getStatusLabel(day.intervals[0].status , day) }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="day.intervals.length === 2">
          <div class="half-circle">
            <span class="half left" [ngClass]="getStatusClass(day.intervals[0].status)">
              <span class="circle-label" [ngClass]="getStatusClass(day.intervals[0].status)">
                {{ getStatusLabel(day.intervals[0].status, day) }}
              </span>
            </span>
            <span class="half right" [ngClass]="getStatusClass(day.intervals[1].status)">
              <span class="circle-label" [ngClass]="getStatusClass(day.intervals[1].status)">
                {{ getStatusLabel(day.intervals[1].status, day) }}
              </span>
            </span>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>

  <!-- Print/Status View -->
  <div class="calendar-dates-row" *ngIf="isShowPrintStatus">
    <div class="calendar-date-cell" *ngFor="let day of availability">
      <!-- SAT/SUN: Grey out and show strikeout calendar icon -->
      <ng-container *ngIf="day.day === 'Sat' || day.day === 'Sun'; else weekdayBlock">
        <div class="circle sat-sun-grey">
          <i class="bi bi-calendar-x sat-sun-icon"></i>
        </div>
      </ng-container>
      <!-- Weekdays: Show status info -->
      <ng-template #weekdayBlock>
        <ng-container *ngIf="day.intervals.length === 1">
          <div class="circle" [ngClass]="getStatusClass(day.intervals[0].status)">
            <span class="circle-label">{{ getStatusLabel(day.intervals[0].status , day) }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="day.intervals.length === 2">
          <div class="half-circle">
            <span class="half left" [ngClass]="getStatusClass(day.intervals[0].status)">
              <span class="circle-label" [ngClass]="getStatusClass(day.intervals[0].status)">
                {{ getStatusLabel(day.intervals[0].status, day) }}
              </span>
            </span>
            <span class="half right" [ngClass]="getStatusClass(day.intervals[1].status)">
              <span class="circle-label" [ngClass]="getStatusClass(day.intervals[1].status)">
                {{ getStatusLabel(day.intervals[1].status, day) }}
              </span>
            </span>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>